module.exports = __webpack_public_path__ + "static/media/icc_pasar.364f443c.png";